import React from 'react';
import './GameOverlay.css';

const GameOverlay = ({ title, message, onStart, onClose }) => {
  const handleOverlayClick = (e) => {
    // Close overlay when clicking on the background (only for How to Play)
    if (title === 'How to Play' && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="game-overlay" onClick={handleOverlayClick}>
      <div className="overlay-content">
        {title === 'How to Play' && (
          <button className="close-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        )}
        <h2>{title}</h2>
        <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
        {title !== 'How to Play' && (
          <button className="start-btn" onClick={onStart}>
            {title === 'Game Over!' ? 'Play Again' : 
             title === 'Game Paused' ? 'Resume' : 'Start Game'}
          </button>
        )}
        {title === 'Whack a Anoma' && (
          <div className="credit">
            Made with 💚 by @mcdaoxyz
          </div>
        )}
      </div>
    </div>
  );
};

export default GameOverlay;

